<div class="bell-schedules-list-content">
  <div class="no-school" *ngIf="!hasSelectedSchool">
    The Bell Schedules configuration page can only be accessed for an individual
    school. Please select one and try again!
  </div>
  <div class="content" *ngIf="hasSelectedSchool">
    <app-bell-schedules-list-filters
      [filters]="filters"
      (filtersUpdated)="updateFilters($event)"
    ></app-bell-schedules-list-filters>
    <app-bell-schedules-list-table
      [dataArr]="bellSchedules"
      [tableFilters]="filters.tableFilters"
      (tableFiltersUpdated)="updateTableFilters($event)"
      (updateTable)="updateBellSchedulesList(filters)"
    ></app-bell-schedules-list-table>
  </div>
</div>
